import { FormAdapter, FormAlert, FormContainerOptions, FormControlType, FormValues } from '@omegagrid/form';
import { msg } from "@omegagrid/localize";
import rp from '@reporting/rp-app-host';
import { Page } from '@reporting/rp-types/wiki';

export class PageFormAdapter extends FormAdapter {

	constructor(
		private a: number,
		private page: Page,
		public path: string = null
	) { super() }

	getColumns() {
		return [
			{width: 125},
			{width: null},
		];
	}

	async getControls() {
		let folder: string;
		let name: string;
		if(this.page.name || this.path) {
			const nameArray = (this.page.name ? this.page.name.split('/') : this.path.split('/')) || [];
			name = nameArray.pop();
			folder = nameArray.join('/');
			if (folder) folder += '/';
		}
		const rows = [
			{row: 0, col: 0, type: FormControlType.Label, value: msg('Folder'), for: 'folder'},
			{row: 0, col: 1, type: FormControlType.TextInput, key: 'folder', value: folder || null},
			{row: 1, col: 0, type: FormControlType.Label, value: msg('Name'), for: 'name'},
			{row: 1, col: 1, type: FormControlType.TextInput, key: 'name', required: true, value: name},
			{row: 2, col: 0, type: FormControlType.Label, value: msg('Show'), for: 'sidebar'},
			{row: 2, col: 1, type: FormControlType.Checkbox, key: 'sidebar', value: this.page.sidebar || false},
			{row: 3, col: 0, type: FormControlType.Label, value: msg('Main page'), for: 'main_page'},
			{row: 3, col: 1, type: FormControlType.Checkbox, key: 'main_page', value: this.page.main_page || false},
		];
		if (this.a) {
			rows.push(
				{row: 4, col: 0, type: FormControlType.Label, value: msg('Synchronization'), for: 'sync'},
				{row: 4, col: 1, type: FormControlType.Checkbox, key: 'sync', value: this.page.sync ?? true},
			);
		}
		if(this.page.id_wiki_page && !this.page.idz) {
			rows.push({row: 5, col: 1, type: FormControlType.Label,
				value: `${msg('You are creating')} ${this.page.lang.toUpperCase()} ${msg('translation for page')} #${this.page.id_wiki_page}!`,
				for: ''});
		}
		return rows;
	}

	getOptions(): FormContainerOptions {
		return {
			caption: null,
			buttonsPosition: 'bottom',
			alertsPosition: 'bottom',
			buttons: [
				"save",
				"close"
			]
		};
	}

	async save(values: Map<string|number, FormValues>): Promise<boolean|FormAlert[]> {
		const formValues = values.get(0);
		let folder: string = formValues.folder ? formValues.folder as string : '';
		if(folder && folder[folder.length - 1] !== '/') folder += '/';
		this.page.name = `${folder}${formValues.name}`;
		this.page.sidebar = formValues.sidebar as boolean;
		this.page.main_page = formValues.main_page as boolean;
		if (this.a) this.page.sync = formValues.sync as boolean;
		await rp.ms('wiki').post<Page>(`pages`, this.page, { accounting: this.a });
		return true;
	}

};
